import React, { Component, Fragment } from "react"
// import ScrollAnimation from 'react-animate-on-scroll'
// import { RedirectProps } from 'react-static'
import { Helmet } from "react-helmet"


import { ContactForm } from "./components"

class Contact extends Component{
  
  
  submit = (values) => {
    // print the form values to the console
    // console.log(this.props)
    // console.log(values)
    
    // Save to local storage for data passing
    // const items = localStorage.setItem(values)

    const uriapp = `https://afrodesiamedia.com/admin/api/collections/save/contacts?token=7289370ee7736e97be508a8fba6003`

    const uriform = `https://afrodesiamedia.com/admin/api/forms/submit/contactus?token=7289370ee7736e97be508a8fba6003`

    // POST TO COLLECTION API

    fetch(uriapp, {
        method: 'post',
        // mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
           data: values,
        })  
        
    })
    .then(collection => collection.json())
    .then(collection => console.log(collection))
    this.props.history.push('/thank-you')
    localStorage.setItem('values', values);

  // POST TO FORM API 

  fetch(uriform, {
      method: 'post', 
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
          form: values
      })
  })
  .then(entry => entry.json())
  // .then(entry => console.log(entry));
  // this.props.history.push('/thank-you')
  // localStorage.setItem({form: values});
  //   console.log(values)
  // }
  console.log(values)
  }

  render(){ 
    return(
       <Fragment>
        <Helmet>
          <title> Contact - afrodesiamedia </title>
          <link rel="shortcut icon" href="/favicon.ico"/>
          <meta property="og:title" content="Contact" />
        </Helmet>
        <section className="Contact">
         <header className="heading">

          <h1>Contact</h1>

        </header>
          <div className="container">

            <div className="form-holder">
              <aside>
                <div>
                  <h3>Got something??</h3>
                  <p>Contact us for any inquiry about our services.</p>
                </div>
              </aside>
              <ContactForm onSubmit={this.submit} />
            </div>

           </div>
         </section>
      </Fragment>
    )
  }
}
export default Contact



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Contact/Contact.js